import { CONSORS_FAMILY_STATUSES } from 'cpool-constants';
import { z } from 'zod';

export const schemaConsorsFamilyStatus = z.nativeEnum(CONSORS_FAMILY_STATUSES);
export type SchemaConsorsFamilyStatus = z.infer<typeof schemaConsorsFamilyStatus>;
